module.exports = __webpack_public_path__ + "static/media/addministrator.8f129008.png";